'use client';

import { usePathname } from 'next/navigation';
import { isActivePathname } from '@/shared/lib/is-active-pathname';
import { Separator, Text } from '@/shared/ui/core';
import { Sidebar, SidebarItem } from '@/shared/ui/layout';
import {
    SealCheckIcon, ClockCounterClockwiseIcon, WarningIcon, UserIcon, WalletIcon, CoinsIcon, QuestionIcon,
    UsersThreeIcon,
} from '@phosphor-icons/react/dist/ssr';
import {
    ACCOUNT_PATHNAME, BILLING_PATHNAME, HISTORY_PATHNAME, REPORT_PATHNAME, SUBSCRIPTION_PATHNAME, SUPPORT_PATHNAME,
    TEAM_PATHNAME, VERIFICATION_PATHNAME,
} from '@/shared/constants/pathnames';
import styles from './navigation.module.scss';


const LINKS_TOP = [
    { href: VERIFICATION_PATHNAME, icon: <SealCheckIcon size={ 24 }/>, labelText: 'Verification', title: 'Verification' },
    { href: HISTORY_PATHNAME, icon: <ClockCounterClockwiseIcon size={ 24 }/>, labelText: 'History', title: 'History' },
    { href: REPORT_PATHNAME, icon: <WarningIcon size={ 24 }/>, labelText: 'Report<span/>incident', title: 'Report incident' },
];
const LINKS_MIDDLE = [
    { href: ACCOUNT_PATHNAME, icon: <UserIcon size={ 24 }/>, labelText: 'Account', title: 'Account' },
    { href: TEAM_PATHNAME, icon: <UsersThreeIcon size={ 24 }/>, labelText: 'Team', title: 'Team' },
    { href: SUBSCRIPTION_PATHNAME, icon: <WalletIcon size={ 24 }/>, labelText: 'Subscription', title: 'Subscription' },
    { href: BILLING_PATHNAME, icon: <CoinsIcon size={ 24 }/>, labelText: 'Billing &<span/>payment', title: 'Billing & payment' },
];
const LINKS_BOTTOM = [
    { href: SUPPORT_PATHNAME, icon: <QuestionIcon size={ 24 }/>, labelText: 'Support', title: 'Support' },
];


type ComponentProps = {
    onClick?: () => void;
    teamEnabled?: boolean;
}


export const Navigation = ({ onClick = () => {}, teamEnabled = true }: ComponentProps) => {
    const pathname = usePathname();
    const linksMiddle = teamEnabled
        ? LINKS_MIDDLE
        : LINKS_MIDDLE.filter(({ href }) => href !== TEAM_PATHNAME);

    return (
        <Sidebar className={ styles.root }>
            {
                LINKS_TOP.map(({ href, icon, labelText, title }) => {
                    const active = isActivePathname(pathname, href);

                    return (
                        <SidebarItem
                            key={ href }
                            active={ active }
                            className={ styles.item }
                            href={ href }
                            icon={ icon }
                            title={ title }
                            onClick={ onClick }
                            label={
                                <Text
                                    tone='primary'
                                    weight='medium'
                                    className={ styles.label }
                                    dangerouslySetInnerHTML={ { __html: labelText } }
                                />
                            }
                        />
                    );
                })
            }

            <Separator className={ styles.separator } />

            {
                linksMiddle.map(({ href, icon, labelText, title }) => {
                    const active = isActivePathname(pathname, href);

                    return (
                        <SidebarItem
                            key={ href }
                            active={ active }
                            className={ styles.item }
                            href={ href }
                            icon={ icon }
                            title={ title }
                            onClick={ onClick }
                            label={
                                <Text
                                    tone='primary'
                                    weight='medium'
                                    className={ styles.label }
                                    dangerouslySetInnerHTML={ { __html: labelText } }
                                />
                            }
                        />
                    );
                })
            }

            <Separator className={ styles.separator } />

            {
                LINKS_BOTTOM.map(({ href, icon, labelText, title }) => {
                    const active = isActivePathname(pathname, href);

                    return (
                        <SidebarItem
                            key={ href }
                            active={ active }
                            className={ styles.item }
                            href={ href }
                            icon={ icon }
                            title={ title }
                            onClick={ onClick }
                            label={
                                <Text
                                    tone='primary'
                                    weight='medium'
                                    className={ styles.label }
                                    dangerouslySetInnerHTML={ { __html: labelText } }
                                />
                            }
                        />
                    );
                })
            }
        </Sidebar>
    );
};
